import { send_z3k_command } from 'z3k-settings/redux/actions';
import { selectDevice } from 'entities/device/lib';
import { getAPIErrorMessage } from 'api';
export const close_device_offline_z3k_custom_command = (device_id, object_id) => ({
    type: 'SEND_Z3K_CUSTOM_COMMAND__CLOSE_DEVICE_OFFLINE',
    device_id,
    object_id,
});
export const send_z3k_custom_command = (device_id, command, request_time = new Date().getTime()) => async (dispatch, getState, { api }) => {
    const device = selectDevice(getState(), device_id);
    dispatch({
        type: 'SEND_Z3K_CUSTOM_COMMAND__REQUEST',
        device_id,
        object_id: command.object_id,
        state: !command.command_args
            ? 0
            : 'mode_id' in command.command_args
                ? command.command_args.mode_id
                : command.command_args.state,
        request_time,
    });
    try {
        await api.send_z3k_command(device_id, command, true, request_time);
        if (!device?.online) {
            dispatch({
                type: 'SEND_Z3K_CUSTOM_COMMAND__SHOW_DEVICE_OFFLINE',
                device_id,
                object_id: command.object_id,
                request_time,
            });
        }
    }
    catch (error) {
        const { json } = error;
        console.log(json);
        const error_message = getAPIErrorMessage(error, 'Произошла ошибка');
        dispatch({
            type: 'SEND_Z3K_CUSTOM_COMMAND__FAIL',
            device_id,
            object_id: command.object_id,
            request_time,
            error_message,
        });
        setTimeout(() => dispatch({
            type: 'RESET_Z3K_CUSTOM_COMMAND__FAIL',
            device_id,
            object_id: command.object_id,
            request_time,
        }), 0);
    }
};
export const onZ3kCustomCommandSuccess = (device_id, object_id, request_time) => ({
    type: 'SEND_Z3K_CUSTOM_COMMAND__SUCCESS',
    device_id,
    object_id,
    request_time,
});
export const onZ3kCustomCommandFail = (device_id, object_id, request_time, error_message) => ({
    type: 'SEND_Z3K_CUSTOM_COMMAND__FAIL',
    device_id,
    object_id,
    request_time,
    error_message,
});
export const onZ3kCustomCommandFailReset = (device_id, object_id, request_time) => ({
    type: 'RESET_Z3K_CUSTOM_COMMAND__FAIL',
    device_id,
    object_id,
    request_time,
});
export function changeHeatingMode(device_id, mode_id) {
    return send_z3k_custom_command(device_id, {
        command_name: 'SelectHeatingMode',
        object_id: mode_id,
        command_args: {
            state: 1,
        },
    }, 1000);
}
export function changeHeatingModeForHeatingCircuit(device_id, mode_id, circuit_id) {
    return send_z3k_custom_command(device_id, {
        command_name: 'SelectHeatingModeForCircuit',
        object_id: circuit_id,
        command_args: {
            mode_id,
        },
    }, 1000);
}
export function setExternalPanel(device_id, boiler_id, switchedOn) {
    return send_z3k_command(device_id, boiler_id, 'ExternalPanel', { shouldAllow: switchedOn }, null, true);
}
